const mapColors = (allColor) => {
    return allColor.nodes.reduce((obj, { name, text, background }) => {
      obj[name] = { text, background };
  
      return obj;
    }, {});
  };
  
  export default mapColors;
  